import { useEffect, useState } from "preact/hooks";
import { html } from "htm/preact"

const helperSetCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie =
    name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
};

// Retrieve a cookie by name. Returns empty string if not found.
const helperGetCookie = (name) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");
  const prefix = name + "=";

  for (let i = 0; i < cookieArray.length; i++) {
    let c = cookieArray[i].trim();
    if (c.indexOf(prefix) === 0) {
      return c.substring(prefix.length, c.length);
    }
  }
  return "";
};

// Main function to handle language preference logic
const helperHandleLanguageSwitch = (langCode) => {
  const currentLang = helperGetCookie("nf_lang");
  // If no cookie or a different language is selected, set/update the cookie
  if (!currentLang || currentLang !== langCode) {
    helperSetCookie("nf_lang", langCode, 365); // Example: valid for 1 year
  }
};

export default function LocaleSwitcher({
  lang,
  locales,
  pages,
}) {
  const [open, setOpen] = useState(false);

  const langBtnListener = () => {
    setOpen(!open);
  }

  function selectLanguage(language) {
    helperHandleLanguageSwitch(language);
  }

  useEffect(() => {

    const langBtn = document.querySelector("#langBtn"),
      langNav = document.querySelector("#langNav");

    if (langBtn) {
      const documentListener = (e) => {
        if (
          !langBtn.contains(e.target) &&
          !langNav.contains(e.target)
        ) {
          setOpen(false);
        }
      }

      document.addEventListener("click", documentListener);
    }
    return () => document.removeEventListener("click", documentListener);
  }, [])

  function getLanguage() {
    for (const locale of locales) {
      if (locale.code == lang) {
        return `${locale.title}`
      }
    }
  }

  return html`
      <button type="button" onclick=${langBtnListener} id="langBtn" class="cursor-pointer flex items-center gap-2 select-none transition rounded-md ring-0 ring-offset-0 py-2 px-2 text-gray-900 ${open ? "bg-stone-100" : ""} border border-transparent hover:border-current lg:py2 lg:px-3" title="{{ i18n.ui.change_language[lang] }}">
        <span class="sr-only lg:not-sr-only order-2">
          ${getLanguage()}
        </span>
        <svg class="stroke-2 stroke-stone-800 size-5 sm:size-4" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="23" stroke-linejoin="round"></circle>
          <path d="M23 1C23 1 15 10.4901 15 24C15 37.5099 23 47 23 47" stroke-linejoin="round"></path>
          <path d="M25 1C25 1 33 10.4901 33 24C33 37.5099 25 47 25 47" stroke-linejoin="round"></path>
          <path d="M1 24H47"></path>
        </svg>
      </button>
      <div class="${open ? "" : "hidden"} absolute right-0 top-1 z-30 mt-10 w-48 origin-bottom-left border border-stone-200 rounded-md bg-white shadow-lg focus:outline-none"
        id="langNav"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="locale-button"
        tabindex="-1">
        <div class="py-1 p-4 text-m leading-6 text-stone-900 " role="none">
        ${Object.values(pages).map(page => {
    for (const locale of locales) {
      if (page.lang == locale.code) {
        return html`
              <div key=${page.lang}>
                <a 
                  href=${page.url}
                  title=${locale.title}
                  lang=${page.lang}
                  onclick=${() => selectLanguage(page.lang)}
                  class="flex p-2 select-none text-sm transition mr-2 text-stone-700 ${page.lang == lang
                  ? "font-semibold text-stone-900"
                  : ""}"
                >
                  ${locale.title}
                </a>
              </div>`
      }
    }
  })}      
        </div>
      </div>
  `;

}

